import { useState,useEffect } from "react";
import { CheckCircle,Crown, Link as LinkIcon,Dumbbell, Trophy, Users, Waves, Target, Bike,ArrowLeft, CheckCircle2, Gift, Sparkles, Check } from "lucide-react";
import VendorPayment from "../Payment/VedorPaymentHandler";
import { ButtonWithLoader } from "@/components/ui/buttonwithloader";
import { createPaymentOrderForDirectBookingLinkSubscription,verifyDirectBookingLinkSubscriptionPayment } from "@/store/thunkMidddleware/paymentMiddleware";
import { Values } from "@/constants/Values";
import { getCompletedVenueDetails } from '@/store/thunkMidddleware/turfMiddleware';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks'
import { RootState } from '@/store';
import SelectVenueForSubscription from './SelectVenueForSubscription'
import { VenuesDetailsInterface } from "@/types/venueInterfaceType";
import { toast } from "@/components/ui/sonner";
import { Badge } from "@/components/ui/badge";


import { Card ,CardHeader,CardContent,CardTitle} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Separator } from '@/components/ui/separator';
import moment from "moment";
import { getPriceWithInr } from "@/lib/utils";


type DirectBookingPremiumProps = {
  selectedVenueId:string,
  vendorId:string,
  planId?:string,
  venue:any
  closeHandler:()=>void
  getVendorDBLVenuesSubscription?:()=>void
};


  const DirectBookingPremium = ({selectedVenueId,vendorId,planId,venue,closeHandler}:DirectBookingPremiumProps) => {

  // const [billing, setBilling] = useState<"monthly" | "yearly">("monthly");
  const [billing, setBilling] = useState<String>(Values.billingCycleKeys.lifetime);

  const [isLoading,setIsLoading]= useState(false)
  const [initPayment,setInitPayment]= useState(false)
  // const [selectedVenueId,setSelectedVenueId]= useState(null)
  const [venueData,setVenueData]= useState<VenuesDetailsInterface[]>(null)

  const[showSelectVenueForSubscriptionComponent,setShowSelectVenueForSubscriptionComponent]= useState(false);
  const dispatch = useAppDispatch()
  const { completedVenueDetails } = useAppSelector((state: RootState) => state.turf);
  const {getSubscriptionPlanDetailsResponse} = useAppSelector((state) => state.payment);

    console.log("selectedVenueId.........",selectedVenueId)

  useEffect(()=>{
    fetchCompletedVenueDetails()
    let now= moment()
    const daysLeft = moment(venue?.subscriptionDetails?.directBookingLink?.expiryDate).diff(now, "days");
    if(venue?.subscriptionDetails?.planId === Values.vendorSubscriptionsPlanId.DBL_Monthly && daysLeft > Values.RENEWAL_WINDOW_DAYS_MONTHLY){
      setBilling(Values.billingCycleKeys.yearly)
    }
  },[])
const handlePayment=()=>{
  setIsLoading(true)
  if(selectedVenueId){
    setInitPayment(true)
  }else{

  }


}


const fetchCompletedVenueDetails = (responseHandler=null) => {
  dispatch(getCompletedVenueDetails({
    callback: (res) => {
      console.log("getCompletedVenueDetails:", res)
      setVenueData(res?.payload)
      if(responseHandler){
        responseHandler(res)
      }
    }
  }))
}

const getPlanId=(value:String)=>{
  switch(value){
    case Values.billingCycleKeys.monthly:
          return Values.vendorSubscriptionsPlanId.DBL_Monthly
    case Values.billingCycleKeys.yearly:
         return Values.vendorSubscriptionsPlanId.DBL_Yearly

    case Values.billingCycleKeys.lifetime:
         return Values.vendorSubscriptionsPlanId.DBL_LIFETIME

    default: return null
  }
}




const renderBiilingCTA=()=>{
  return (<div className="flex items-center gap-4 mb-10 absolute right-4 top-4">
    {/* Toggle wrapper */}

    <div className="  rounded-full shadow-inner border border-flup-hairline-2 flex items-center py-2 px-4 bg-green-600">
    <p className="font-bold text-xs text-white">{billing?.toUpperCase()}</p>

    </div>
    {/* <div className="relative bg-flup-surface rounded-full shadow-inner border border-flup-hairline-2 flex items-center px-1 py-1 w-32 h-[38px]"> */}
      
      {/* SLIDER BACKGROUND */}
      {/* <div
        className={`
          absolute top-1 bottom-1 w-1/2 rounded-full bg-green-600 transition-all duration-300 
          ${billing === Values.billingCycleKeys.monthly  ? "left-1" : "left-[calc(48%+0px)]"}
        `}
      ></div> */}

      {/* MONTHLY BUTTON */}
      {/* <button
        onClick={() => setBilling(Values.billingCycleKeys.monthly)}
        className={`relative z-10 w-full text-[8px] font-semibold py-2 transition ${
          billing === Values.billingCycleKeys.monthly ? "text-white" : "text-flup-ink-2"
        }`}
      >
        MONTHLY
      </button> */}

      {/* YEARLY BUTTON */}
      {/* <button
        onClick={() => setBilling(Values.billingCycleKeys.yearly)}
        className={`relative z-10 w-full text-[8px] font-semibold py-2 transition ${
          billing === Values.billingCycleKeys.yearly ? "text-white" : "text-flup-ink-2"
        }`}
      >
        YEARLY
      </button> */}
    {/* </div> */}

  </div>
  )
}

const getActiveSubscriptionBtntxt=(subscription:any)=>{
  if(!subscription?.planId){
    return "Subscribe Now"
  }

  // let now= moment()
  // const daysLeft = moment(subscription?.directBookingLink?.expiryDate).diff(now, "days");

  if(subscription?.planId === Values.vendorSubscriptionsPlanId.DBL_Monthly){
    return "Upgrade Now"
  }else{
    return "Renew Now"
  }
}

const getBtnCTA=(subscription:any)=>{
  if(!subscription?.planId){
    return(
      //  {/* CTA Button */}
       <div className="text-center mb-4 mt-2">
 
       <ButtonWithLoader
       onClick={handlePayment}
       loaderPosition="right"
       isLoading={isLoading || initPayment || completedVenueDetails.isLoading}
       className="
         bg-flup-brand text-white
         hover:bg-gradient-to-r hover:from-green-600 hover:to-blue-600
         text-white font-semibold 
         text-lg py-4 px-10 rounded-xl shadow-md 
         flex items-center gap-2 mx-auto transition-all
         h-12
         rounded-lg
         w-80
       ">
         <LinkIcon className="h-6 w-6" />
         {getActiveSubscriptionBtntxt(venue?.subscriptionDetails)}
        </ButtonWithLoader>
    </div>
  )
    }
  let now= moment()
  const daysLeft = moment(subscription?.directBookingLink?.expiryDate).diff(now, "days");
  if(subscription?.planId === Values.vendorSubscriptionsPlanId.DBL_Monthly && daysLeft > Values.RENEWAL_WINDOW_DAYS_MONTHLY && billing === Values.billingCycleKeys.monthly){
      return (<div className="flex justify-center items-center space-x-2 border-2 border-flup-hairline rounded-lg p-1
              h-12 bg-gradient-to-br from-purple-100 to-blue-100 dark:from-purple-900/30 dark:to-blue-900/30 border-purple-200 dark:border-purple-800
              mb-4 mt-2
      ">
          {/* Decorative corner */}
    {/* <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-purple-300/40 to-transparent rounded-bl-full" /> */}

                <div className="w-8 h-8 bg-gradient-to-br from-pink-400 to-purple-500 rounded-full flex items-center justify-center shadow-lg">
                    <Crown className="w-5 h-5 text-white" />
                  </div>

              {/* <Crown className="w-6 h-6 text-purple-700" /> */}
              <p className="text-md font-semibold text-flup-brand">
                Your Monthly plan is active till {moment(subscription?.directBookingLink?.expiryDate).format("DD MMM YYYY")},You can renew only in the last { Values.RENEWAL_WINDOW_DAYS_MONTHLY} days.
              </p>
        </div>)
    }else{
      return(
            //  {/* CTA Button */}
             <div className="text-center mb-4 mt-2">
             <ButtonWithLoader
             onClick={handlePayment}
             loaderPosition="right"
             isLoading={isLoading || initPayment || completedVenueDetails.isLoading}
             className="
               bg-flup-brand text-white
               hover:bg-gradient-to-r hover:from-green-600 hover:to-blue-600
               text-white font-semibold 
               text-lg py-4 px-10 rounded-xl shadow-md 
               flex items-center gap-2 mx-auto transition-all
               h-12
               rounded-lg
               w-80
             ">
               <LinkIcon className="h-6 w-6" />
               {getActiveSubscriptionBtntxt(venue?.subscriptionDetails)}
             </ButtonWithLoader>
         </div>
      )
    }
}

  return (
    <>
    
    {initPayment && selectedVenueId && <VendorPayment
      backDropcloseHandler={closeHandler}
      apiCreateOrder={createPaymentOrderForDirectBookingLinkSubscription}
      apiVerifyPayment={verifyDirectBookingLinkSubscriptionPayment}
      onClose={()=>{
        console.log("Payment gateway closed!")
        setInitPayment(false)
        // setSelectedVenueId(null)
        setIsLoading(false)

      }}
      onSuccess={(paymentdata)=>{
        console.log("payment succesfully captured:",paymentdata)
        setInitPayment(false)
        // setSelectedVenueId(null)
        setIsLoading(false)
      }}
      purchaseType={Values.purchaseType.directBooking}
      metadata={{
        promoCode:null,
        planId: getPlanId(billing),
        venueId:selectedVenueId
      }}
    />}

< div className="mb-4">
    {/* Offer Card */}
    <Card className="mb-8 p-6 bg-gradient-to-br from-purple-100 to-blue-100 dark:from-purple-900/30 dark:to-blue-900/30 border-purple-200 dark:border-purple-800 relative overflow-hidden">
  
  {/* Decorative corner */}
  <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-purple-300/40 to-transparent rounded-bl-full" />

  <div className="flex items-center justify-between gap-6">
    
    {/* LEFT: Offer + Price */}
    <div className="flex items-center gap-4 min-w-[260px]">
      <div className="w-16 h-16 bg-gradient-to-br from-pink-400 to-purple-500 rounded-2xl flex items-center justify-center shadow-lg">
        <Gift className="w-8 h-8 text-white" />
      </div>

      <div>
        <div className="inline-flex items-center gap-1 bg-foreground text-background text-xs font-medium px-3 py-1 rounded-full mb-1">
          <Sparkles className="w-3 h-3" />
          {getSubscriptionPlanDetailsResponse?.payload?.find(ele=>ele?.planId === getPlanId(billing))?.discountValue}% discount
        </div>

        <p className="text-2xl font-bold text-foreground leading-tight">
          {getPlanId(billing) === Values.vendorSubscriptionsPlanId.DBL_Yearly?
              <> Only ₹{((getSubscriptionPlanDetailsResponse?.payload?.find(ele=>ele?.planId === getPlanId(billing))?.discountAmount)/12)?.toFixed(2)}{" "}</>
          :
          <> Only ₹{(getSubscriptionPlanDetailsResponse?.payload?.find(ele=>ele?.planId === getPlanId(billing))?.discountAmount)}{" "}</>
          }
          {/* Only ₹{((getSubscriptionPlanDetailsResponse?.payload?.find(ele=>ele?.planId === getPlanId(billing))?.discountAmount)/12)?.toFixed(2)}{" "} */}
          <span className="text-sm font-normal text-muted-foreground">
            / month
          </span>
        </p>

        <p className="text-sm text-muted-foreground">
          Lowest price ever
        </p>
      </div>
    </div>

    {/* CENTER: Plan Info */}
    {/* <div className="flex-1 text-center px-6">
      <h2 className="text-2xl font-bold text-flup-ink">
        Direct Booking Link – {billing?.charAt(0).toUpperCase()} Plan
      </h2>
      <p className="text-flup-ink-3 mt-1">
        Best for venues who want 0% commission bookings and full automation.
      </p>
    </div> */}

    {/* RIGHT: Billing CTA */}
    <div className="min-w-[220px] flex justify-end">
      {renderBiilingCTA()}
    </div>

  </div>
    </Card>


    <div className="w-full  flex flex-col items-center">     

      {/* Pricing Card */}
      <div className="
        bg-flup-surface rounded-3xl shadow-xl border border-flup-hairline 
        w-full max-w-4xl p-6 relative overflow-hidden
      ">

        {/* Glow Background Accent */}
        <div className="absolute inset-0 bg-gradient-to-tr from-purple-100 via-transparent to-transparent opacity-60 pointer-events-none" />

        {/* Card Content */}
        <div className="relative z-10">
        <div className="grid gap-2 grid-cols-1 md:grid-cols-2">
            {/* Left */}
             <div>
              {/* Plan Name */}
                <h2 className="text-2xl font-bold text-flup-ink mb-3 text-start">
                  Direct Booking Link – <span className="text-lg">{billing?.toUpperCase()} Plan </span>
                </h2>

                <p className="text-flup-ink-3 text-start mb-4">
                  Best for venues who want 0% commission bookings and full automation.
                </p>

                {/* Dynamic Price */}
                <div className="text-start mb-4">
                  <span className="text-3xl font-extrabold text-green-500 ">
                  {/* <span className="text-5xl font-extrabold text-green-500 text-flup-brand"> */}

                    {/* {billing === Values.billingCycleKeys.monthly  ? "₹599" : "₹5600"} */}
                    {getPriceWithInr(getSubscriptionPlanDetailsResponse?.payload?.find(ele=>ele?.planId === getPlanId(billing))?.amountBreakup?.payableAmount)}

                  </span>
                  <span className="text-flup-ink-3 text-xl">
                    {billing === Values.billingCycleKeys.monthly  ? " / month" : billing === Values.billingCycleKeys.yearly?" / year":"/ Lifetime"}
                  </span>
                  <p className="text-muted-foreground">Inclusive of 18% GST</p>

                  <p className="text-[12px] text-flup-ink-3 mt-2">
                    Instant activation · Cancel anytime · Secure Razorpay payment
                  </p>
                </div>
            </div>
            {/* <Separator  orientation="vertical"/> */}
            {/* right */}
              {venue &&<div>
                <Card
                key={venue._id}
                className="border-2 border-green-200 bg-flup-surface shadow-lg hover:shadow-xl transition-shadow relative"
              >

                  {/* Decorative corner */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-purple-300/40 to-transparent rounded-bl-full" />
                <div className="px-5 py-4">

               
                <div className="px-0">
                  <div className="flex items-start justify-between">
                    <div className="flex gap-4">
                      <img
                        src={venue?.venueThumbnail}
                        alt={venue?.name}
                        className="w-16 h-16 rounded-lg object-cover"
                      />
                      <div>
                        <CardTitle className="text-lg">{venue?.name}</CardTitle>
                          <p className="text-sm text-muted-foreground">
                            {venue?.address?.address} {venue?.address?.locality} {venue?.address?.state}
                          </p>
                          <div className="text-sm text-muted-foreground flex justify-between items-center">
                            <span> Plan Id:</span>
                           <Badge
                            variant="outline"
                            className="border-blue-500 text-flup-info"
                            >
                              {getPlanId(billing)}
                            </Badge>
                          </div>
                      </div>
                    </div>
                    {/* <Badge className="bg-green-500 hover:bg-green-600">
                      <Check className="w-3 h-3 mr-1" />
                      Active
                    </Badge> */}
                  </div>
                </div>
                    <div className="bg-gradient-to-bl from-purple-700/40  rounded-lg px-2 py-1 space-y-1 mt-2">
                
                        <div className="flex items-center justify-between text-[12px]">
                          <span className="text-flup-ink-2 flex items-center gap-1">
                            Base Price:
                          </span>
                          <span className="font-medium">
                          {getPriceWithInr(getSubscriptionPlanDetailsResponse?.payload?.find(ele=>ele?.planId === getPlanId(billing))?.amountBreakup?.finalPrice?.toFixed(2))}
                          </span>
                      </div>
                      <div className="flex items-center justify-between  text-[12px]">
                          <span className="text-flup-ink-2 flex items-center gap-1">
                            GST(18%):
                          </span>
                          <span className="font-medium">
                          {getPriceWithInr((getSubscriptionPlanDetailsResponse?.payload?.find(ele=>ele?.planId === getPlanId(billing))?.amountBreakup?.gstAmount?.toFixed(2)))}

                          </span>
                      </div>
                      <div className="flex items-center justify-between text-[12px]">
                          <span className="text-flup-ink-2 flex items-center gap-1">
                          Total Payable:
                          </span>
                          <span className="font-medium">
                            {getPriceWithInr((getSubscriptionPlanDetailsResponse?.payload?.find(ele=>ele?.planId === getPlanId(billing))?.amountBreakup?.payableAmount))}
                          </span>
                      </div>
                    </div>
                  </div>
              </Card>
              </div>}
          </div>


              {getBtnCTA(venue?.subscriptionDetails)}
          
          {/* Features */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4 mt-3">
            {[
              "Your own booking link",
              "Instant WhatsApp confirmations",
              "Online payment collection",
              "Slot calendar & pricing display",
              "0% commission for your customers",
              "Dashboard analytics",
              "Fast activation",
              "Professional booking experience",
            ].map((item, idx) => (
              <div key={idx} className="flex items-start gap-3">
                <CheckCircle className="h-4 w-4 text-flup-info" />
                <p className="text-flup-ink-2 text-base text-sm">{item}</p>
              </div>
            ))}
          </div>

     
        </div>
      </div>
    </div>
    </div>
    {/* } */}
    </>
  );
}


export default DirectBookingPremium;